import React, { useEffect, useState } from "react";
import {
  AppBar,
  Toolbar,
  Button,
  Avatar,
  Box,
  Typography,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import { Link, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { AppState } from "../../store";
import { useAuth } from "../../utils/userAuth";
import { apiClient } from "../../utils/apiClient";
import { UserInfo, AdminListUsersResponse, AdminUpdateSettingsBody, AdminUpdateSettingsResponse } from "@services/admin/types";

interface InternalPageProps {
  children: React.ReactNode;
  title?: string;
  containerStyle?: any;
}

const InternalPage: React.FC<InternalPageProps> = ({
  children,
  containerStyle,
}) => {
  const { isLoggedIn } = useAuth();
  const user = useSelector(
    ({ userData }: AppState) => userData.user,
    (a, b) => a?.id === b?.id
  );

  const [allUsers, setAllUsers] = useState<UserInfo[]>([]);
  const [selectedUserId, setSelectedUserId] = useState<string>("");

  useEffect(() => {
    const fetchUsers = async () => {
      const response = await apiClient.post<AdminListUsersResponse>(
        "/admin/list_users",
        {}
      );
      setAllUsers(response.users);
    };
    fetchUsers();
  }, []);

  if (!isLoggedIn && !user?.isAdmin) {
    return <Navigate to={`/user/login?redirectUrl=${encodeURIComponent(window.location.href)}`} replace />;
  }
  return (
    <div>
      <AppBar position="static">
        <Toolbar>
          {/* Icon on the top-left */}
          <Avatar
            src="/www/assets/dobby_internal_tools_icon.png"
            alt="Dobby Tools Icon"
            sx={{ marginRight: 2, width: 40, height: 40 }}
          />

          {/* Navigation Buttons */}
          <div style={{ display: "flex", overflow: "auto", width: "100%" }}>
            <div style={{ display: "flex" }}>
              <Button color="inherit" component={Link} to="/internal/workflows">
                Workflows
              </Button>
            </div>
          </div>
          <Box flexGrow="1" />

          {/* User selection */}
          <FormControl variant="outlined" size="small" sx={{ minWidth: 160 }}>
            <Select
              sx={{ fontSize: 12, color: "white" }}
              value={selectedUserId}
              displayEmpty
              onChange={async (e: any) => {
                const userId = e.target.value;
                setSelectedUserId(userId);
                const res =
                  await apiClient.post<AdminUpdateSettingsResponse>(
                    "/admin/update_admin_settings",
                    {
                      impersonatedUser: userId,
                    } satisfies AdminUpdateSettingsBody
                  );
                if (res.success) window.location.reload();
              }}
            >
              <MenuItem value="">User: {user?.email}</MenuItem>
              {allUsers.map((u) => (
                <MenuItem key={u.id} value={u.id}>
                  {u.email}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Toolbar>
      </AppBar>

      <div style={{ marginTop: "20px", ...(containerStyle || {}) }}>
        {children}
      </div>
    </div>
  );
};

export default InternalPage;
